




















































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import Loader from "../ui/Loader.vue";

@Component({
  components: {
    Loader,
  },
})
export default class LeaseAssets extends Vue {
  @Prop() assetsList: any;
  isLoading = false;
}
